import React from "react";
import SpinningLogo from "../../assets/images/MWHLoadingScreenLogo.png";

const LoadingScreen = (props) => {
  const isAuthVariant = props.variant === "auth";
  const isPropertiesVariant = props.variant === "properties";

  return (
    <div
      className={`loadingScreen ${isAuthVariant ? "loadingScreen--auth" : ""} ${isPropertiesVariant ? "loadingScreen--properties" : ""} ${props.transparent ? "loadingScreen--transparent" : ""}`}
      style={{
        position: props.position,
        height: props.height,
        zIndex: 100,
        backgroundColor: props.transparent ? "transparent" : undefined,
      }}
    >
      <div
        className={`loadingHero d-flex justify-content-center w-100 p-2 ${isAuthVariant ? "loadingHero--auth" : ""} ${isPropertiesVariant ? "loadingHero--properties" : ""}`}
        style={{ marginTop: props.marginTop }}
      >
        <div
          className={`loadingHero__content ${isAuthVariant ? "loadingHero__content--auth" : ""} ${isPropertiesVariant ? "loadingHero__content--properties" : ""}`}
        >
          <div className="d-flex justify-content-center">
            <img
              src={SpinningLogo}
              className={`loadingHero__logo ${isAuthVariant ? "loadingHero__logo--auth" : ""} ${isPropertiesVariant ? "loadingHero__logo--properties" : ""}`}
              style={{ width: props.width + "vw" }}
              alt=""
            />
          </div>
          <h1
            className={`loadingHero__title ${isAuthVariant ? "loadingHero__title--auth" : ""} ${isPropertiesVariant ? "loadingHero__title--properties" : ""}`}
            style={
              !isAuthVariant && !isPropertiesVariant
                ? { fontSize: props.width / 5 + "vw" }
                : undefined
            }
          >
            {props.input}
          </h1>
          {isAuthVariant && (
            <p className="loadingHero__subtitle">Preparing your workspace...</p>
          )}
          {isPropertiesVariant && (
            <p className="loadingHero__subtitle loadingHero__subtitle--properties">
              {props.subtitle || "Loading object properties..."}
            </p>
          )}
        </div>
        {/* {props.showModelLoadProgress && (
          <div className="mt-3" style={{ fontSize: "1.5vw" }}>
            {props.numberOfLoadedGlobalModels} / {props.totalGlobalModels}{" "}
            Models Loaded
          </div>
        )} */}
      </div>
    </div>
  );
};

export default LoadingScreen;
